export function timeFormat(timeInSeconds: number) {
	let minutes = Math.floor(timeInSeconds / 60);
	let seconds = timeInSeconds % 60;

	return `${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
}

export const eurocentFormat = (amount: number) => {
	return (amount / 100).toFixed(2);
};
